import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/workouts-new/workouts.css";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchWorkoutEquipmentsData } from "../../redux/workout-reducers/workoutApis";
import CommonFilterStructure from "../../components/common-components/CommonFilterStructure";
import AllEquipments from "../../components/workouts-new/equipments/AllEquipments";

const WorkoutEquipments = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { loading, equipmentsData } = useSelector((state) => state.workoutApi);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
    setIsPage(0);
  }

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getWorkoutEquipments(filters) {
    dispatch(
      fetchWorkoutEquipmentsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    getWorkoutEquipments(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Workout Exercise">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"All Equipments"}
              createBtnTxt={"+ Add Equipment"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonFilterStructure
              from={"only-search"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllEquipments
              tbDatas={equipmentsData}
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() => {
                getWorkoutEquipments(filters);
              }}
              userInfoData={userInfoData}
              modValues={modValues}
              setModValues={setModValues}
              onCloseModalvalues={onCloseModalvalues}
              isAllEquipmentsLoading={loading}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WorkoutEquipments;
